import {selectAppConfig} from "modules/app/selectors/selectAppConfig";

export const selectClientApplicationId = state => selectAppConfig(state).client_application_id || null;
